import { TableCell, toCurrencyString, TableRow } from '@client/toolkit';
import { TableExpandableCell } from '../../components/table-expanable-cell';
import React from 'react';
import { InvoiceRow } from './invoice-row';
import { TenantAccountsReceivableDto, InvoiceReceivableDto } from '@client/api';
import { useTranslation } from 'react-i18next';
import { CurrencyCode } from '@client/toolkit';

export const TenantRow = ({
  tenant,
  handleToggleExpand,
  handleKeyDownExpand,
  expandedRows,
}: {
  tenant: TenantAccountsReceivableDto;
  handleToggleExpand: (id: string) => void;
  handleKeyDownExpand: (e: React.KeyboardEvent<Element>, id: string) => void;
  expandedRows: Set<string>;
}) => {
  const { t } = useTranslation('reporting');
  return (
    <React.Fragment key={tenant.tenantId}>
      <TableRow className="bg-surface-base border-b border-surface-elevated">
        <TableCell className="px-2 py-2"></TableCell>
        <TableCell className="px-2 py-2"></TableCell>
        <TableExpandableCell
          label={tenant.tenantName}
          onClick={() => handleToggleExpand(tenant.tenantId)}
          onKeyDown={(e) => handleKeyDownExpand(e, tenant.tenantId)}
          ariaLabel={
            expandedRows.has(tenant.tenantId)
              ? t('table.selectedEntity', { entityName: tenant.tenantName })
              : t('table.expandedEntity', { entityName: tenant.tenantName })
          }
          isExpanded={expandedRows.has(tenant.tenantId)}
        />
        <TableCell className="px-2 py-2 align-top">
          {toCurrencyString(tenant.currentPeriodOutstanding.value, '-', {
            currency: tenant.currentPeriodOutstanding.currency as CurrencyCode,
            maximumFractionDigits: 0,
          })}
        </TableCell>
        <TableCell className="px-2 py-2 align-top">
          {toCurrencyString(tenant.comparisonPeriodOutstanding.value, '-', {
            currency: tenant.comparisonPeriodOutstanding.currency as CurrencyCode,
            maximumFractionDigits: 0,
          })}
        </TableCell>
        <TableCell className="px-2 py-2 align-top">{t('invoicesCount', { count: tenant.invoices?.length })}</TableCell>
        <TableCell className="px-2 py-2 align-top">-</TableCell>
        <TableCell className="px-2 py-2 align-top">-</TableCell>
      </TableRow>
      {expandedRows.has(tenant.tenantId) &&
        tenant.invoices?.map((invoice: InvoiceReceivableDto) => (
          <InvoiceRow key={invoice.invoiceId} invoice={invoice} />
        ))}
    </React.Fragment>
  );
};
